import { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Download, X } from 'lucide-react';

export function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }
    // Check if dismissed recently
    const dismissedAt = localStorage.getItem('pwa-install-dismissed');
    if (dismissedAt && Date.now() - parseInt(dismissedAt) < 86400000) {
      setDismissed(true);
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    window.addEventListener('appinstalled', () => setIsInstalled(true));
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === 'accepted') setIsInstalled(true);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('pwa-install-dismissed', Date.now().toString());
  };

  if (isInstalled || dismissed || !deferredPrompt) return null;

  return (
    <div className="lg:hidden fixed top-16 left-0 right-0 z-40 px-3 py-2 animate-in slide-in-from-top-2 duration-300" data-testid="pwa-install-prompt">
      <div className="bg-gradient-to-r from-[#002FA7] to-[#0047FF] rounded-xl px-4 py-3 flex items-center gap-3 shadow-lg">
        <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center flex-shrink-0">
          <Download className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-white text-sm font-medium">Install AIVORA Nexus</p>
          <p className="text-blue-200 text-xs">Add to home screen for the best experience</p>
        </div>
        <Button size="sm" className="bg-white text-[#002FA7] hover:bg-blue-50 text-xs font-semibold h-8 px-3" onClick={handleInstall} data-testid="pwa-install-btn">
          Install
        </Button>
        <button onClick={handleDismiss} className="text-white/60 hover:text-white p-1" data-testid="pwa-dismiss-btn">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
